var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareonpinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.313,
    height: 27.463,
    viewBox: "0 0 22.313 27.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pinterest",
    d: "M59.534,0C52.007,0,48,4.823,48,10.083c0,2.439,1.363,5.481,3.545,6.445.331.149.512.086.585-.221.065-.233.352-1.358.491-1.888a.485.485,0,0,0-.117-.477,6.254,6.254,0,0,1-1.3-3.8c0-3.668,2.916-7.23,7.879-7.23,4.291,0,7.293,2.788,7.293,6.775,0,4.506-2.384,7.623-5.483,7.623A2.455,2.455,0,0,1,58.312,14.3c.489-1.983,1.449-4.114,1.449-5.544a2.13,2.13,0,0,0-2.2-2.343c-1.746,0-3.162,1.729-3.162,4.049a5.773,5.773,0,0,0,.522,2.47s-1.727,6.976-2.048,8.279A18.524,18.524,0,0,0,53,27.3a.181.181,0,0,0,.33.084,21.626,21.626,0,0,0,2.843-5.354c.213-.784,1.087-3.965,1.087-3.965a4.745,4.745,0,0,0,4,1.909c5.259,0,9.06-4.623,9.06-10.359C70.3,4.114,65.591,0,59.534,0",
    transform: "translate(-48.004)",
    fill: "#d32f2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareonpinterest);
export default __webpack_public_path__ + "static/media/shareonpinterest.e798d6ffa6793b1461e3a6a528c4da6c.svg";
export { ForwardRef as ReactComponent };